import React from 'react';
import { Hero } from '../components/Hero';
import { ClassFormats } from '../components/ClassFormats';
import { WhyDesertSage } from '../components/WhyDesertSage';
import { Testimonials } from '../components/Testimonials';
import { SupportCTA } from '../components/SupportCTA';
export function HomePage() {
  return <>
      <Hero data-id="element-576" />
      <ClassFormats data-id="element-577" />
      <WhyDesertSage data-id="element-578" />
      <Testimonials data-id="element-579" />
      <SupportCTA data-id="element-580" />
    </>;
}